import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import BookingList_Item_MoreDrop from "../../BookingList/MoreDrop/BookingList_Item_MoreDrop";
import {useCustomLogic} from "../../../utils/customLogic";
import * as constants from "../../../utils/constants";
import * as actionTypes from "../../../store/actions/actionTypes";
import {MODAL_BOOKING_FILE_SHOW} from "../../../store/actions/actionTypes";
import {openBookingSmsModal} from "../../../store/actions/bookingList";

const BookingList_Item = ({booking}) => {
    const dispatch = useDispatch();
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const {smsSendingIds} = useSelector(state => state.bookingList);
    const isSending = smsSendingIds.indexOf(booking.id) > -1;
    const wasSent = !!booking.lastSmsSendAt;

    const openSmsModal = () => dispatch(openBookingSmsModal(booking));

    const openPreAdmissionModal = () => dispatch({
        type: actionTypes.MODAL_BOOKING_PRE_ADMISSION_SET_SHOW,
        booking,
        customUiId: selectedHospital.booking_preAdmission?.customUiId,
    });

    const showModalViewFile = (file, booking) => {
        dispatch({
            type: actionTypes.MODAL_BOOKING_FILE_SHOW,
            file: file,
            booking: booking
        });
    }

    const showEmail = () => {
        if (booking.email) {
            return (
                <a href={`mailto:${booking.email}`} className="no-underline">
                    <span className="info-tooltip" data-tip={`${booking.email}`}>
                        <i className="icon ico-c-info" />
                    </span>
                </a>
            )
        }
        return null;
    }

    return (
        <tr>
            <td style={{ minWidth: '150px'}}>{booking.surgeon}</td>
            <td className=""><_Source source={booking.source}/></td>
            <td className="">{booking.uid}{showEmail()}</td>
            <td className="">{booking.firstName}</td>
            <td className="">{booking.surname}</td>
            <td className="">{booking.phone}</td>
            <td className="">{booking.dob}</td>
            <td className="">{booking.procedureDate}</td>
            <td className="">{booking.procedureReason}</td>
            <td className="">{booking.createdAt}</td>
            <td className="">
                {booking.files.length > 0 ? (
                    <ul className="pl-2">
                        {booking.files.map((file, index) => (
                            <li key={index} className="hover:underline pointer" onClick={() => showModalViewFile(file, booking)}>{file.originalName || file.fileName}</li>
                        ))}
                    </ul>
                ) : (
                    <span className="text-gray-500">No files</span>
                )}
            </td>
            {selectedHospital.booking_preAdmission && (
                <td>
                    {booking.preAdmission_id ? (
                        <button type="button" className="btn btn-sm btn-success" disabled>
                            <span className="icon ico-checkmark" />
                        </button>
                    ) : (
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={openPreAdmissionModal}>-</button>
                    )}
                </td>
            )}
            {selectedHospital.booking_sendSms_enable && (
                <td>
                    <button type="button"
                            className={`btn btn-sm ${wasSent ? 'btn-outline-primary' : 'btn-primary'}`}
                            disabled={isSending}
                            onClick={openSmsModal}>
                        {isSending ? 'Sending…' : (wasSent ? 'Resend' : 'Send')}
                    </button>
                    {wasSent && (
                        <div className="small text-muted mt-1" data-tip={booking.lastSmsSendAt}>
                            Sent {booking.lastSmsSendAt}
                        </div>
                    )}
                </td>
            )}
            <td>
                <div className="d-inline-flex align-items-center">
                    <BookingList_Item_MoreDrop booking={booking}/>
                </div>
            </td>
        </tr>
    )
}


const areEqual = (prevProps, nextProps) => {
    // console.log('[Are Equal?]', JSON.stringify(prevProps) === JSON.stringify(nextProps));
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

const _Source = ({source}) => {
    // booking.source comes from Booking::getSourceConst() ('SOURCE_WEB' | 'SOURCE_PANACEA').
    const labels = {
        SOURCE_WEB: 'Web',
        SOURCE_PANACEA: 'Panacea',
    };

    return <span>{labels[source] || source}</span>;
}

export default BookingList_Item;
export const BookingList_Item_Memo = React.memo(BookingList_Item, areEqual);